module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_9005.ba166325.png";